import "@/app/style/videoThumbnail.scss";
import { IconButton } from "@mui/material";
import { defaultValue } from "@/app/utils/Common";
import ExternalVideoPlayer from "./ExternalVideoPlayer";
import { useMyContext } from "@/app/utils/MyContext";

export const generateVideoInfo = (title?: string, imgSrc?: string, isValid?: boolean, akamaiKey?: string, exDiv?: string, exScript?: string, external?: boolean) => {
  if (!title && !imgSrc && !akamaiKey) return
  return {
    title: title,
    imgSrc: imgSrc,
    isValid: isValid,
    akamaiKey: akamaiKey,
    exDiv: exDiv,
    exScript: exScript,
    external: external,
  } as VideoInfo;
}

export interface VideoInfo {
  title?: string;
  imgSrc?: string;
  isValid?: boolean;
  akamaiKey?: string;
  exDiv?: string;
  exScript?: string;
  external?: boolean;
}

interface ThumbnailProps extends VideoInfo {
  variant?: "standard" | "list";
  customeTitleSlot?: React.ReactNode;
  onClick: (e:any)=>void;
  enableShare?: boolean;
}

const VideoThumbnail = (props: ThumbnailProps) => {
  const {state: myContextState} = useMyContext();
  const hasImg = props.imgSrc ? true : false
  const hasVideo = props.isValid ? true : false
  const generateThumbnail = (external?: boolean)=>{
    return external ? <div className="videoThumbnailImage">
      <ExternalVideoPlayer divEle={props.exDiv} jsScript={props.exScript} />
    </div> :
    <>
      {
        hasImg && <img
          className="videoThumbnailImage"
          src={props.imgSrc}
          alt={props.title}
          onError={(e:any)=>e.target.style.opacity=0}
        />
      }
      {
        hasVideo && <div className="playIconContainer">
          <img src={`${myContextState.assetPrefix}/videoGallery_play.svg`} />
        </div>
      }
    </>
  }

  return (
    <div className={`videoThumbnail ${props.variant ? props.variant : "standard"}${props.isValid && props.akamaiKey ? " clickable" : ""}`}>
      <div className={`imageWrapper${props.external || !hasImg ? ' withRatio': ''}`} onClick={(e)=>props.onClick(e)}>
        {
          generateThumbnail(props.external)
        }
      </div>
      <div className="titleWrapper">
        { props.customeTitleSlot ? props.customeTitleSlot : <div className="title linebreak">{defaultValue(props.title, '')}</div> }
        {
          hasVideo && props.enableShare && <IconButton className="shareBtn" aria-label="share"
            onClick={(e:any)=>{
              e.stopPropagation();
              console.log('click share');
            }}
          >
            <img src={`${myContextState.assetPrefix}/share.svg`} />
          </IconButton>
        }
      </div>
    </div>
  )
}

export default VideoThumbnail;